"use client";

import React, { Fragment } from "react";
import { Popover, Transition } from "@headlessui/react";
import Checkbox from "@/shared/Checkbox";
import ButtonThird from "@/shared/ButtonThird";
import ButtonPrimary from "@/shared/ButtonPrimary";
import { useAppDispatch, useAppSelector } from "@/app/lib/hooks";
import { setFilter } from "@/app/lib/reducers/toursReducer";
import { useTranslation } from 'react-i18next';

const durations = [
  { name: "0 - 3 heures", value: "0-3" },
  { name: "3 - 5 heures", value: "3-5" },
  { name: "5 - 7 heures", value: "5-7" },
  { name: "Journée complète (7 heures et +)", value: "7-48" },
  { name: "2 jours", value: "48-71" },
  { name: "3 jours", value: "72-95" },
  { name: "4 jours", value: "96-119" },
  { name: "+ de 5 jours", value: "120" },
];

const DurationFilter: React.FC = () => {
  const dispatch = useAppDispatch();
  const selectedDurations = useAppSelector((state) => state.tours.filters.duration);
  const { t } = useTranslation("guydeez");

  const handleChange = (val: string) => {
    const updated = selectedDurations.includes(val)
      ? selectedDurations.filter((v) => v !== val)
      : [...selectedDurations, val];
    dispatch(setFilter("duration", updated));
  };

  return (
    <Popover className="relative">
      {({ open, close }) => (
        <>
          <Popover.Button
            className={`flex items-center justify-center px-4 py-2 text-sm rounded-full border border-neutral-300 dark:border-neutral-700 hover:border-neutral-400 dark:hover:border-neutral-600 focus:outline-none ${
              open ? "!border-primary-500" : ""
            }`}
          >
            <span>{t('filter_duration')}</span>
            <i className="las la-angle-down ml-2" />
          </Popover.Button>

          <Transition
            as={Fragment}
            enter="transition ease-out duration-200"
            enterFrom="opacity-0 translate-y-1"
            enterTo="opacity-100 translate-y-0"
            leave="transition ease-in duration-150"
            leaveFrom="opacity-100 translate-y-0"
            leaveTo="opacity-0 translate-y-1"
          >
            <Popover.Panel className="absolute z-50 w-screen max-w-sm px-4 mt-3 sm:px-0 lg:max-w-md">
              <div className="overflow-hidden rounded-2xl shadow-xl bg-white dark:bg-neutral-900 border border-neutral-200 dark:border-neutral-700">
                <div className="relative flex flex-col px-5 py-6 space-y-5">
                  {durations.map((item) => (
                    <Checkbox
                      key={item.value}
                      name={item.name}
                      label={item.name}
                      defaultChecked={selectedDurations.includes(item.value)}
                      onChange={() => handleChange(item.value)}
                    />
                  ))}
                </div>
                <div className="p-5 bg-neutral-50 dark:bg-neutral-900 dark:border-t dark:border-neutral-800 flex items-center justify-between">
                  <ButtonThird onClick={close} sizeClass="px-4 py-2 sm:px-5">
                    {t('filter_clear')}
                  </ButtonThird>
                  <ButtonPrimary onClick={close} sizeClass="px-4 py-2 sm:px-5">
                    {t('filter_apply')}
                  </ButtonPrimary>
                </div>
              </div>
            </Popover.Panel>
          </Transition>
        </>
      )}
    </Popover>
  );
};

export default DurationFilter;
